// posthogUtils.js
import { PostHog } from 'posthog-js/react';

import { IUser } from "../../interfaces/User";
import { EventName, Properties } from 'posthog-js';

/**
 * Identifies a user in PostHog.
 * @param {Object} posthog - The PostHog object.
 * @param {Object} user - The user object containing user details.
 */

const TRACKING_APP_NAME = 'washday-frontend';
export function identifyUser(posthog: PostHog, user: IUser, companyId: string) {
    if (!posthog) return;
    posthog.identify(user._id, {
        email: user.email,
        app: TRACKING_APP_NAME,
    });
    posthog.group('company', companyId);
}

/**
 * Tracks an event in PostHog.
 * @param {Object} posthog - The PostHog object.
 * @param {string} event - The name of the event to track.
 * @param {Object} properties - Properties to attach to the event.
 */
export function trackEvent(posthog: PostHog, event: EventName, properties: Properties = {}) {
    if (!posthog) return;
    posthog.capture(event, {
        ...properties,
        app: TRACKING_APP_NAME,
    });
}

/**
 * Sets user properties in PostHog.
 * @param {Object} posthog - The PostHog object.
 * @param {Object} userProperties - The properties to set for the user.
 */
export function setUserProperties(posthog: PostHog, userProperties: any) {
    if (!posthog) return;

    posthog.setPersonProperties(userProperties)
}
